export const sortAwaitingPickupOrders = (order1, order2) => {
	return new Date(order1.pickupMetaData?.awaitingPickupDate ?? 0).getTime() - new Date(order2.pickupMetaData?.awaitingPickupDate ?? 0).getTime()
}

export const sortProcessingPickupOrders = (order1, order2) => {
	return new Date(order1.pickupMetaData?.processingPickupDate ?? 0).getTime() - new Date(order2.pickupMetaData?.processingPickupDate ?? 0).getTime()
}
